import {videoLessonRoute} from './module/videoLesson'
import {ROLE_SUPER_USER, ROLE_USER} from '../../helpers'

export const UserRoute = [
  {
    path: 'main',
    name: 'UserMain',
    component: () => import('../../components/User/Main.vue'),
    meta: {
      access: [ROLE_USER, ROLE_SUPER_USER]
    }
  },
  {
    path: 'plan-education',
    name: 'planEducation',
    component: () => import('../../components/User/planEducation.vue'),
    meta: {
      access: [ROLE_USER, ROLE_SUPER_USER]
    }
  },
  {
    path: 'tests',
    name: 'UserTests',
    component: () => import('../../components/User/Tests.vue'),
    meta: {
      access: [ROLE_USER, ROLE_SUPER_USER]
    }
  },
  {
    path: 'webinars',
    name: 'UserWebinars',
    component: () => import('../../components/User/Webinars.vue'),
    meta: {
      access: [ROLE_USER, ROLE_SUPER_USER]
    }
  },
  {
    path: 'video-lesson',
    component: () => import('../../components/router-view'),
    children: videoLessonRoute
  },
  {
    path: 'scorm-package',
    name: 'UserScormPackage',
    component: () => import('../../components/User/scormPackage.vue'),
    meta: {
      access: [ROLE_USER, ROLE_SUPER_USER]
    }
  },
  {
    path: 'scorm-package-iframe/:id',
    component: () => import('../../components/User/scormPackageIframe.vue'),
    meta: {
      access: [ROLE_USER, ROLE_SUPER_USER]
    }
  },
  {
    path: 'vr',
    name: 'UserVR',
    component: () => import('../../components/User/vr.vue'),
    meta: {
      access: [ROLE_USER, ROLE_SUPER_USER]
    }
  },
  {
    path: 'media-files',
    name: 'UserMediaFiles',
    component: () => import('../../components/User/mediaFiles.vue'),
    meta: {
      access: [ROLE_USER, ROLE_SUPER_USER]
    }
  },
  {
    path: 'testing/:id',
    name: 'testing',
    component: () => import('../../components/User/Testing.vue'),
    props: (route) => ({
      ...route.params
    }),
    meta: {
      access: [ROLE_USER, ROLE_SUPER_USER]
    }
  },
  {
    path: 'webinar-view/:id',
    name: 'WebinarView',
    component: () => import('../../components/User/webinarView.vue'),
    meta: {
      access: [ROLE_USER, ROLE_SUPER_USER]
    }
  },
  {
    path: 'test-list/:id',
    component: () => import('../../components/User/testList.vue'),
    meta: {
      access: [ROLE_USER, ROLE_SUPER_USER]
    }
  },
  {
    path: 'chat-webinar/:id',
    component: () => import('../../components/User/chatWebinar.vue'),
    meta: {
      access: [ROLE_USER]
    }
  },
  {
    path: 'chat-webinar-messages/:id',
    component: () => import('../../components/User/chatWebinarMessages.vue'),
    meta: {
      access: [ROLE_USER]
    }
  },
  // {
  //   path: 'support',
  //   name: 'supportHelp',
  //   component: () => import('../../components/User/support.vue'),
  //   meta: {
  //     access: [ROLE_USER]
  //   }
  // }
  {
    path: 'support-request',
    component: () => import('../../components/router-view'),
    children: [
      {
        path: '',
        name: 'supportHelp',
        component: () => import('../../components/User/support/'),
        meta: {
          access: [ROLE_USER]
        }
      },
      {
        path: 'create',
        name: 'supportHelpCreate',
        component: () => import('../../components/User/support/create'),
        meta: {
          access: [ROLE_USER]
        }
      },
      {
        path: ':id',
        name: 'supportHelpShow',
        component: () => import('../../components/User/support/show'),
        meta: {
          access: [ROLE_USER]
        }
      }
    ]
  }

]



// WEBPACK FOOTER //
// ./src/router/user/index.js